import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-privacy-policy',
  standalone: true,
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent implements OnInit {
  pdfUrl!: SafeResourceUrl;
  pdfDirectUrl = 'assets/docs/aviso-privacidad.pdf';

  constructor(
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    const uuidc = this.route.snapshot.queryParams['uuidc'];
    if (uuidc && ['2228', '2665', '2559', '2907', '2988'].includes(uuidc)) {
      localStorage.setItem('uuidClient', uuidc);
    }
    // Redirección directa al PDF
    window.open(this.pdfDirectUrl, '_blank');
    window.history.back();
  }
}